module.exports = __webpack_public_path__ + "static/img/IL.807d3282.png";